import { MenuItem, Paper, Stack, Typography } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { LANGUAGES, VOICES } from '../constants';
import { Voice } from '../types';
import Select from './SelectField';
import { FormValues } from './Widget';

interface Props {
	isLoading: boolean;
}

export default function Filters({ isLoading }: Props) {
	const { control, watch, setValue } = useFormContext<FormValues>();

	const language = watch('language');

	const voiceOptions = useMemo<Voice[]>(
		() => VOICES.filter((el) => el.language === language),
		[language]
	);

	useEffect(() => {
		setValue('voice', voiceOptions[0].code);
	}, [voiceOptions]);

	return (
		<Stack spacing={1}>
			<Select
				control={control}
				name="language"
				label="Язык"
				formControlProps={{ disabled: isLoading }}
			>
				{LANGUAGES.map((language) => (
					<MenuItem value={language.code} key={`language-${language.code}`}>
						{language.label}
					</MenuItem>
				))}
			</Select>
			<Select
				control={control}
				name="voice"
				label="Голос"
				formControlProps={{ disabled: isLoading }}
			>
				{voiceOptions.map((voice) => (
					<MenuItem value={voice.code} key={`voice-${voice.code}`}>
						{voice.label}
					</MenuItem>
				))}
			</Select>
		</Stack>
	);
}
